module.exports = __webpack_public_path__ + "static/sf-ui-medium-57cb79565e92f1d4c4a92eacd2cd6996.ttf";